import s from './LoreTwoProductSidebar.module.scss'
import cn from 'clsx'
import { useAddItem } from '@framework/cart'
import { FC, useState } from 'react'
import { ModalInner, LoreTwoProductOptions } from '@components/product'
import useRemoveItem from '@framework/cart/use-remove-item'
import useCart from '@framework/cart/use-cart'
import type {
  Product,
  ProductOption,
  ProductVariant,
} from '@commerce/types/product'
import { Text, Modal, Button } from '@components/ui'
import { getProductVariant, SelectedOptions } from '../helpers'
import {
  LoreTwo as ProductPage,
  FindFitterBlock,
  Fitter,
} from '@generated/model/models'
import { FittersBlock } from '@components/loretwopage'

interface LoreTwoProductSidebarProps {
  page: ProductPage
  product: Product
  relatedProducts: Product[]
  className?: string
  setCurrentSlide: React.Dispatch<React.SetStateAction<number>>
  defaultOptions: SelectedOptions
  fitters: Fitter[]
  fittersData: FindFitterBlock
  currentFitter: Fitter | null
  setCurrentFitter: React.Dispatch<React.SetStateAction<Fitter | null>>
}

export interface CartLine {
  [key: string]: {
    selectedOptions?: SelectedOptions
    variant?: ProductVariant
  }
}

const LoreTwoProductSidebar: FC<LoreTwoProductSidebarProps> = ({
  page,
  product,
  className,
  setCurrentSlide,
  defaultOptions,
  fitters,
  fittersData,
  currentFitter,
  setCurrentFitter,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [fittersModalOpen, setFittersModalOpen] = useState(false)
  const [selectedOptions, setSelectedOptions] =
    useState<SelectedOptions>(defaultOptions)

  const addItem = useAddItem()
  const removeItem = useRemoveItem()
  const { data, isLoading, isEmpty } = useCart()
  const [modalProps, setModalProps] = useState({
    title: '',
    section: {},
    variant: 'one',
    showImage: false,
  })

  const [cartLines, setCartLines] = useState<CartLine>({})
  const [validCart, setValidCart] = useState(true)

  const handleSetOptions = async (
    option: ProductOption,
    value: any,
    e: any
  ) => {
    setFittersModalOpen(false)

    setValidCart(true)

    const resetCut =
      option.displayName.toLowerCase() === 'material' &&
      value.label.toLowerCase() === 'nylon'

    let newOptions = {
      [option.displayName.toLowerCase()]: value.label.toLowerCase(),
    }

    if (resetCut) {
      newOptions = {
        ...newOptions,
        cut: 'low',
      }
    }

    setSelectedOptions((selectedOptions) => {
      return {
        ...selectedOptions,
        ...newOptions,
      }
    })

    setCartLines((cartLines) => {
      return {
        ...cartLines,
        [product.id]: {
          ...selectedOptions,
          ...newOptions,
        },
      }
    })
    const variant = getProductVariant(product, {
      ...selectedOptions,
      ...newOptions,
    } as any)

    const variantIndex = product.variants
      .filter((variant) => variant.defaultImage)
      // .filter((variant) => variant.)
      .findIndex((v) => v.id === variant?.id)

    const slideNumber = product.images.length + variantIndex

    setCurrentSlide(slideNumber)

    try {
      const item = data?.lineItems?.find(
        (lineitem) => lineitem.productId == product.id
      )
      if (item) {
        await removeItem({ id: item.id })
      }
    } catch (err) {
      console.log(err)
    }

    if ((e.target && e.target.checked) || e.target.type != 'radio') {
      try {
        await addItem({
          productId: String(product.id),
          variantId: String(variant ? variant.id : product.variants[0]?.id),
          quantity: 1,
        })
      } catch (err) {
        console.log('ERROR', err)
      }
    }
  }

  return (
    <div className={cn(s.root, className)}>
      <div className={s.sticky}>
        <Text variant="pageHeading" className={s.name}>
          {product.name}
        </Text>

        <LoreTwoProductOptions
          page={page}
          product={product}
          setModalProps={setModalProps}
          setModalOpen={setModalOpen}
          isValid={validCart}
          setIsValid={setValidCart}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          handleChange={handleSetOptions}
        />
        <div className={s.sizeFit}>
          <Text variant="smallText" className={s.sizeFitTitle}>
            {page.size_fit}
          </Text>
          <Text className={s.sizeFitDetail} html={page.size_fit_detail} />
        </div>
      </div>

      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)} className={s.modalWide}>
          <ModalInner {...modalProps} />
        </Modal>
      )}
    </div>
  )
}

export default LoreTwoProductSidebar
